<mat-card-content class="footerBody">

<p>© Copyright {{ htmlData.year }} - All Rights Reserved</p>
</mat-card-content>
